import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

function NotFound() {
  return (
    <div className="h-[80vh] flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      {/* Icon */}
      <div className="flex items-center justify-center mb-6">
        <AlertTriangle className="w-16 h-16 text-yellow-500 animate-bounce" />
      </div>

      {/* 404 Text */}
      <h1 className="text-6xl font-extrabold text-gray-800">404</h1>
      <p className="mt-4 text-xl font-semibold text-gray-700">
        Oops! Page not found.
      </p>
      <p className="mt-2 text-gray-500 text-center max-w-md">
        The page you're looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>

      {/* Buttons */}
      <div className="mt-6 flex gap-4">
        <Link
          to="/"
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md shadow-md transition duration-200"
        >
          Go Home
        </Link>
        <Link
          to="/contact"
          className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-3 rounded-md shadow-md transition duration-200"
        >
          Contact Support
        </Link>
      </div>

      {/* Footer */}
      <div className="mt-10 text-gray-400 text-sm">
        &copy; {new Date().getFullYear()} Exudee Hampers | All Rights Reserved
      </div>
    </div>
  );
}

export default NotFound;
